import React, { Fragment, useState } from "react";
import Select from "react-select";
import { Button, Col, Input, Label, Row } from "reactstrap";
import { ItemTypeahead } from ".";
import { constants } from "../utils";

export default function DynamicInput({ obj, onChangeCallback, idx, ...props }) {
   const [value, setValue] = useState(false);

   const onChangeButton = (e) => {
      setValue(!value);
      onChangeCallback(obj.label, null, idx, null, true);
   };

   if (!obj) return null;
   if (obj.type === constants.INPUT_TYPES.button) {
      if (obj.inventoryButtonValue && !value) {
         setValue(obj.inventoryButtonValue);
      }
      return (
         <Button
            children={obj.name}
            className="filter-button"
            onClick={(e) => onChangeButton(e)}
            active={value}
            disabled={obj.disabled}
         />
      );
   }
   if (obj.type === constants.INPUT_TYPES.typeAhead) {
      <Row key={`${obj.name}-abt`} className="mt-3">
         <Col xs="3" style={{ textAlign: "right", marginRight: "5px" }}>
            <Label>{obj.name}</Label>
         </Col>
         <Col xs="6">
            <ItemTypeahead
               onChange={(e) => { onChangeCallback(obj.label, e, idx, true); }}
               value={obj.textValue}
            />
         </Col>
      </Row>;
   }
   if (obj.type === constants.INPUT_TYPES.text || obj.type === constants.INPUT_TYPES.number) {
      return (
         <Row key={`${obj.name}-abt`} className="mt-2">
            <Col xs="3" style={{ textAlign: "right", marginTop: "6px" }}>
               {obj.name}
            </Col>
            <Col xs="6">
               <Input
                  type={obj.type ?? "text"}
                  value={obj.value || ""}
                  name={obj.label ?? ""}
                  placeholder={obj.placeHolder ?? ""}
                  onChange={(e) => onChangeCallback(e.target.name, e.target.value, idx) }
                  disabled={obj.disable ? true : false}
               />
            </Col>
         </Row>
      );
   } else if (obj.type === constants.INPUT_TYPES.checkbox) {
      if (obj.desc) {
         return (
            <Fragment key={`${obj.name}-abt`}>
               <Row className="mt-3">
                  <Col xs="3" style={{ textAlign: "right", marginRight: "5px" }}>
                     <h5 className="text-white" style={{ marginBottom: "0px" }} >
                        {obj.name}
                     </h5>
                  </Col>
                  <Col xs="6">
                     <Input
                        style={{ marginTop: "10px" }}
                        type="checkbox"
                        name={obj.label}
                        checked={obj.value}
                        onChange={() => onChangeCallback(obj.label, null, idx, null, true)}
                     />
                  </Col>
               </Row>
               <Row key={`${obj.name}-atbt`}>
                  <Col
                     xs="3"
                     className="text-white"
                     style={{ textAlign: "right", marginRight: "5px", fontSize: "small" }}
                  >{`(${obj.desc})`}</Col>
               </Row>
            </Fragment>
         );
      } else {
         return (
            <Row key={`${obj.name}-abt`} className="mt-3">
               {!obj.rightSide && (
                  <Col xs="3" style={{ textAlign: "right", marginRight: "5px" }}>
                     <Label>{obj.name}</Label>
                  </Col>
               )}
               <Col xs={obj.colSize ?? "6"}>
                  <Input
                     type="checkbox"
                     name={obj.label}
                     checked={obj.value}
                     onChange={() => onChangeCallback(obj.label, null, idx, null, true)}
                  />
               </Col>
               {obj.rightSide && (
                  <Col style={{ textAlign: "left", marginRight: "5px" }}>
                     <Label>{obj.name}</Label>
                  </Col>
               )}
            </Row>
         );
      }
   } else if (
      obj.type === constants.INPUT_TYPES.select
      // && obj.options && obj.options?.length
   ) {
      return (
         <Row key={`${obj.name}-xcvt`} className="mt-2">
            <Col xs="3" style={{ textAlign: "right", marginTop: "6px" }}>
               <h5 className="text-white">
                  {obj.name}
               </h5>
            </Col>
            <Col xs="6">
               <Select
                  classNamePrefix='serviceThreadSelect'
                  options={obj.options}
                  value={obj.value}
                  onChange={(e) => onChangeCallback(obj.label, e, idx)}
                  isMulti={obj.isMulti}
               />
            </Col>
         </Row>
      );
   } else if (obj.type === constants.INPUT_TYPES.checkboxANDInput) {
      return (
         <Row key={`${obj.name}-abt`} className="mt-3">
            <Col xs="3" style={{ textAlign: "right", marginRight: "5px" }}>
               <h5 className="text-white">
                  {obj.name}
               </h5>
            </Col>
            <Col xs="1" style={{ paddingRight: "0px" }}>
               <Input
                  type="checkbox"
                  name={obj.label}
                  checked={obj.value}
                  onChange={() => onChangeCallback(obj.label, null, idx)}
               />
            </Col>
            {obj.value ? (
               obj.typeAhead ? (
                  <Col style={{ paddingLeft: "0px", paddingRight: "300px" }}>
                     <ItemTypeahead
                        onChange={(e) => { onChangeCallback(obj.label, e, idx, true); }}
                        value={obj.textValue}
                     />
                  </Col>
               ) : (
                  <Col style={{ paddingLeft: "0px", paddingRight: "300px" }}>
                     <Input
                        type="text"
                        name={obj.label}
                        value={obj.textValue}
                        onChange={(e) => { onChangeCallback(e.target.name, e.target.value, idx, true); }}
                        disabled={obj.disable}
                     />
                  </Col>
               )
            ) : null}
         </Row>
      );
   }
}
